import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { splitLang, localizePath } from '../i18n/routing';
import { FiChevronDown } from 'react-icons/fi';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'uk', name: 'Українська' },
  { code: 'ru', name: 'Русский' },
];

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  const currentLang = languages.find((lang) => lang.code === i18n.resolvedLanguage) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Each language has its own address (/about, /uk/about, /ru/about); remember the choice for next visit
  const changeLanguage = (langCode) => {
    try {
      localStorage.setItem('i18nextLng', langCode);
    } catch {}
    navigate(`${localizePath(splitLang(pathname).path, langCode)}${search}${hash}`);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lang-btn"
        aria-label={t('language.change')}
        aria-expanded={isOpen}
        data-testid="language-switcher"
      >
        <span>{currentLang.code.toUpperCase()}</span>
        <FiChevronDown className={`w-3 h-3 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="lang-menu">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={i18n.resolvedLanguage === lang.code ? 'is-active' : ''}
              data-testid={`lang-${lang.code}`}
            >
              <span className="lang-menu__code">{lang.code.toUpperCase()}</span>
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
